import './index.scss';

export const CustomModal = ({ isOpen, closeModal, children }) => {
  return (
    <>
      {/* Overlay */}
      <div
        className={`custom-modal-overlay ${isOpen ? "visible" : "hidden"}`}
        onClick={closeModal}
      ></div>

      {/* Modal */}
      <div className={`custom-modal ${isOpen ? "visible" : "hidden"}`}>
        {children}
      </div>
    </>
  );
};
